import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import v2Icons from '../../../../formicons/fonts/formicons-v2.json';

import './Icon.module.css';

class Icon extends PureComponent {
  render() {
    const { iconName, fontSize, color, v2 = false } = this.props;

    const showV2 = Object.keys(v2Icons).includes(`fl-${iconName}`);
    if (v2 || showV2) {
      return (
        <i
          className={classnames('fl-v2', `fl-v2-fl-${iconName}`)}
          style={{ fontSize }}
          styleName={color}
        />
      );
    }

    // Fallback for legacy icons
    return (
      <i
        className={`fl-${iconName}`}
        style={{
          fontSize
        }}
        styleName={color}
      />
    );
  }
}

Icon.defaultProps = {
  fontSize: '1rem',
  color: 'black',
  v2: false
};

Icon.propTypes = {
  iconName: PropTypes.string.isRequired,
  fontSize: PropTypes.string,
  color: PropTypes.string,
  v2: PropTypes.bool
};

export default Icon;
